<template>
  <v-card>
    <v-card-title class="title">Estado</v-card-title>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Servicio</th>
              <th class="text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in services" :key="item.name">
              <td class="text-capitalize">{{ item.name }}</td>
              <td
                class="text-capitalize"
                :class="{
                  'red--text': item.value == 'FAILED' ? true : false,
                  'green--text': item.value == 'FAILED' ? false : true,
                }"
              >
                {{ item.value }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  data() {
    return {
      services: [],
    };
  },
  mounted() {
    this.loadStatus();
  },
  methods: {
    loadStatus() {
      this.$http.get(`/api/admin/status`).then((response) => {
        this.services = response.data;
      });
    },
  },
};
</script>

<style>
</style>